<div class="requiredCheckbox__badge__container">
  <mat-icon 
    matBadge="{{(requiredCheckboxTotal$| async).toString()}}"
    matBadgeSize="small"
    matBadgeHidden="{{(requiredCheckboxTotal$| async) === 0}}"
    data-testid="checkbox-text"
    class="requiredCheckbox__badge__icon"
    matBadgePosition="above right"
    matTooltip="Checkboxes"
    matTooltipClass="scorecard-icon-tooltip"
  >
  </mat-icon>
  <span class="cdk-visually-hidden">Count of required Checkbox(es) remaining to sign</span>
</div>
